import {DataFetcher} from '@aboutyou/data-fetcher';
import React, {useEffect} from 'react';
import {useSizesSection} from '../useGetProductBulkSection';
import {AddToBasketSectionSkeleton} from './AddToBasketSectionSkeleton';
import {
  AddToBasketSectionView,
  AddToBasketSectionViewProps,
} from './AddToBasketSectionView';

export const AddToBasketSection = (
  props: Omit<AddToBasketSectionViewProps, 'isInMiniADPDialog'> & {
    ref?: React.Ref<HTMLElement>;
  },
) => {
  const {ref} = props;
  // reset selected size when the product data is refreshed (after being stale)
  // and only if the selected size is soldOut
  useEffect(() => {
    if (props.selectedSize?.availability?.$case === 'soldOut') {
      props.setSelectedSize(undefined);
    }
  }, [props.selectedSize, props.selectedSize?.availability?.$case]);

  return (
    <DataFetcher
      request={useSizesSection({
        currentSize: {
          selectedSize: props.selectedSize,
          setSelectedSize: props.setSelectedSize,
        },
      })}
      Error={() => null}
      Loading={() => <AddToBasketSectionSkeleton className={props.className} />}
      View={viewProps => (
        <AddToBasketSectionView {...viewProps} isInMiniADPDialog={false} />
      )}
      viewProps={{...props, ref}}
    />
  );
};
